<template>
  <v-main>
    <material-snackbar
      v-model="$store.state.app.feedback.show"
      :type="$store.state.app.feedback.color"
    >
      {{ $store.state.app.feedback.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="$store.state.app.feedback.show = false"
        >
          Fechar
        </v-btn>
      </template>
    </material-snackbar>

    <loading v-if="$store.state.app.loading" />

    <v-container fluid>
      <router-view :key="$route.path" />
    </v-container>
  </v-main>
</template>

<script>
  import Loading from '../../components/Loading/Index'

  export default {
    name: 'DefaultView',
    components: { Loading },
    mounted: function () {
      if (!this.$store.state.app.session.token) {
        this.$router.push({
          name: 'Login',
        })
      }
    },
  }
</script>
